import type { KeyboardEvent } from 'react'
import type { DurationPreset } from '@bandos/shared'
import {
  DurationWrapper,
  DurationLabel,
  DurationOptions,
  DurationOption,
  DurationOptionName,
  DurationOptionTime,
} from './DurationSelector.styles'

interface DurationSelectorProps {
  presets: readonly DurationPreset[]
  selectedMinutes: number
  onChange: (minutes: number) => void
}

export function DurationSelector({ presets, selectedMinutes, onChange }: DurationSelectorProps) {
  const handleKeyDown = (e: KeyboardEvent, minutes: number): void => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      onChange(minutes)
    }
  }

  return (
    <DurationWrapper>
      <DurationLabel>Completion time</DurationLabel>
      <DurationOptions role="radiogroup" aria-label="Completion time">
        {presets.map((preset) => (
          <DurationOption
            key={preset.minutes}
            type="button"
            role="radio"
            aria-checked={selectedMinutes === preset.minutes}
            tabIndex={0}
            $selected={selectedMinutes === preset.minutes}
            onClick={() => onChange(preset.minutes)}
            onKeyDown={(e) => handleKeyDown(e, preset.minutes)}
          >
            <DurationOptionName>{preset.label}</DurationOptionName>
            <DurationOptionTime>{preset.description}</DurationOptionTime>
          </DurationOption>
        ))}
      </DurationOptions>
    </DurationWrapper>
  )
}
